import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LocalizedRouterLinkPipe } from '@core/i18n/localized-router-link.pipe';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-not-found-page',
  standalone: true,
  imports: [RouterLink, TranslocoPipe, LocalizedRouterLinkPipe],
  template: `
    <section class="container mx-auto flex min-h-[50vh] flex-col items-center justify-center px-6 py-24 text-center">
      <h1 class="font-display text-3xl font-bold text-foreground md:text-4xl">
        {{ 'pages.notFound.title' | transloco }}
      </h1>
      <p class="mx-auto mt-4 max-w-xl text-muted-foreground">
        {{ 'pages.notFound.description' | transloco }}
      </p>
      <a
        [routerLink]="'/' | localizedRouterLink"
        class="mt-8 inline-flex items-center rounded-full bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground transition hover:opacity-90"
      >
        {{ 'pages.notFound.backHome' | transloco }}
      </a>
    </section>
  `,
})
export class NotFoundPage {}
